import React from "react";
import "./aboutUsContent.scss";
import Text from "componets/atoms/text/text";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
import palette from "styles/palette.scss";
import ArrowButton from "componets/atoms/arrowButton/arrowButton";
import SemiCircleCard from "componets/molecules/circleCard/semiCircleCard";
import PresentationSheet from "componets/molecules/presentationSheet/presentationSheet";
import PresentationSheetContent4 from "componets/molecules/presentationSheetContent4/presentationSheetContent4";

import { ReactMarkdown } from "react-markdown/lib/react-markdown";
// type = sobreNosotros || galeria || misionVision || historia || directorio || mapaSede || direccionSede || planeacion || relacionesI || secretariaSede
const AboutUsContent = ({ data, type }) => {
  const [secretariaSedeButtons, setSecretariaSedeButtons] =
    React.useState(true);
  const [secretariaSedeSelection, setSecretariaSedeSelection] =
    React.useState("consejoSede");
  const handleClickSecretaria = (election) => {
    setSecretariaSedeSelection(election);
    setSecretariaSedeButtons(false);
  };
  return (
    <>
      <div className="about-content__data-container">
        {type === "sobreNosotros" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
            <br />
          </>
        )}
        {type === "galeria" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
            <br />
            <div className="about-content__galery">
              {data.images.map((image, index) => (
                <img key={index} src={image.src} alt={image.alt} />
              ))}
            </div>
          </>
        )}
        {type === "misionVision" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
          </>
        )}
        {type === "historia" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
          </>
        )}
        {type === "directorio" && (
          <div className="about-content__directory-container">
            <div className="about-content__directory-content">
              <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
            </div>
            {data.socialMedia ? (
              <ul className="about-content__social-media">
                <li>
                  <a target="_blank" href={data.socialMedia.facebook}>
                    <img src={require("icons/facebook.png")} alt=""></img>{" "}
                    Facebook
                  </a>
                </li>
                <li>
                  <a target="_blank" href={data.socialMedia.instagram}>
                    <img src={require("icons/instagram.png")} alt=""></img>
                    Instagram
                  </a>
                </li>
                <li>
                  <a target="_blank" href={data.socialMedia.youtube}>
                    <img src={require("icons/youtube.png")} alt=""></img>Youtube
                  </a>
                </li>
                <li>
                  <a target="_blank" href={data.socialMedia.twitter}>
                    <img src={require("icons/twitter.png")} alt=""></img>Twitter
                  </a>
                </li>
              </ul>
            ) : (
              "No se cargaron las redes sociales"
            )}
          </div>
        )}
        {type === "direccionSede" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
            <img
              className="about-content__img"
              src={data.imgSrc}
              alt={data.imgAlt}
            />
          </>
        )}
        {type === "docentes" && (
          <>
            <br />
            {data.professors.map((professor, index) => (
              <React.Fragment key={index}>
                <PresentationSheet
                  image={professor.img}
                  color={palette.offWhite}
                  children={<PresentationSheetContent4 data={professor} />}
                />
                <br />
              </React.Fragment>
            ))}
            <br />
            <img
              className="about-content__img"
              src={data.imgSrc}
              alt={data.imgAlt}
            />
          </>
        )}

        {type === "mapaSede" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15697.589049454376!2d-73.2004202!3d10.3899886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xa717270155f56fa!2sUniversidad%20Nacional%20de%20Colombia%20Sede%20La%20Paz!5e0!3m2!1ses-419!2sco!4v1648156226501!5m2!1ses-419!2sco"
              style={{ height: "30vw", width: "100%", border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </>
        )}
        {type === "planeacion" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
          </>
        )}
        {type === "relacionesI" && (
          <>
            <ReactMarkdown>{data.descriptionMD}</ReactMarkdown>
            <br />
            <br />
            <div className="about-content__arrow-button">
              <Text type="p" textSize={2}>
                DRE{" "}
              </Text>
              <ArrowButton
                textSize={2}
                type="right--2"
                handleClick={() => window.open(data.DRELink, "_blank")}
              />
            </div>
          </>
        )}
        {type === "secretariaSede" && (
          <>
            {secretariaSedeButtons ? (
              <>
                <ReactMarkdown>{"# Secretaría de sede"}</ReactMarkdown>

                <br />
                <SemiCircleCard
                  isSecretary={true}
                  optionalHandle={() => handleClickSecretaria("consejoSede")}
                  type="oval"
                  textSize={2}
                  data={{
                    title: "Consejo de sede",
                    description: data.consejoSede.descripcionCorta,
                    link: "",
                  }}
                />
                <br />
                <br />
                <SemiCircleCard
                  isSecretary={true}
                  optionalHandle={() =>
                    handleClickSecretaria("consejoEscuelas")
                  }
                  type="oval"
                  textSize={2}
                  data={{
                    title: "Consejo de escuelas",
                    description: data.consejoEscuelas.descripcionCorta,
                    link: "",
                  }}
                />
                <br />
                <br />
                <SemiCircleCard
                  isSecretary={true}
                  optionalHandle={() =>
                    handleClickSecretaria("representaciones")
                  }
                  type="oval"
                  textSize={2}
                  data={{
                    title: "Representaciones",
                    description: data.representaciones.descripcionCorta,
                    link: "",
                  }}
                />
                <br />
                <br />
              </>
            ) : (
              <>
                {secretariaSedeSelection == "consejoSede" && (
                  <ReactMarkdown>{data.consejoSede.descripcion}</ReactMarkdown>
                )}
                {secretariaSedeSelection == "representaciones" && (
                  <ReactMarkdown>
                    {data.representaciones.descripcion}
                  </ReactMarkdown>
                )}
                {secretariaSedeSelection == "consejoEscuelas" && (
                  <ReactMarkdown>
                    {data.consejoEscuelas.descripcion}
                  </ReactMarkdown>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AboutUsContent;
